import { IMenuModel } from './menu.models'
import { Component, OnInit } from '@angular/core'
import { MenuService } from './menu.service'
import { EnvironmentService } from 'app/environment.service';
import { LinkService } from 'app/links/link.service';

@Component({
    selector: 'sbw-menu',
    styleUrls: ['./menu.component.css'],
    templateUrl: './menu.component.html'
})

export class MenuComponent implements OnInit {

    public menu: IMenuModel
    public allowContentfulEditing: boolean
    public contentfulEditMode: boolean

    constructor(private menuService: MenuService, private environmentService: EnvironmentService, private links: LinkService) { }

    ngOnInit() {
        this.allowContentfulEditing = this.environmentService.getSbContentfulUsePreview()

        this.menuService.loadMenu().subscribe((data: IMenuModel) => {
            data.MenuItems.filter(item => item.Href && item.Href.indexOf('login') > 0)
                .forEach(item => item.Href += '?returnUrl=' + this.getReturnUrl())

            data.MenuItems.filter(f => f.Href && f.Href.endsWith('amendment/bookings'))
                .forEach(item => { item.Route = this.links.toRoute(item.Href); item.Href = null })

            data.MenuItems.filter(f => f.Href).forEach(item => { item.Href = item.Href })

            this.menu = data
        })
    }

    public toggleContentfulEditing() {
        this.environmentService.setContentfulEditMode(!this.environmentService.contentfulEditMode)
        this.contentfulEditMode = this.environmentService.contentfulEditMode
    }

    private getReturnUrl(): string {
        return location.pathname + location.search
    }

    public getClasses(item): string {
        switch (item.MenuItemType) {
            case 'RequireAuthentication': return 'icon-lock'
            case 'OnlineHelp': return 'icon-bubbles'
            case 'Contact': return 'icon-phone'
            case 'TempSsoAccount': return 'default-cursor temp-sso-account'
        }
    }

    public getTarget(item): string {
        //open chat window in new window
        if (item.MenuItemType == 'OnlineHelp') return '_blank'
    }
}
